// client/src/components/common/NavMenu.js
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Button, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';

const NavMenu = ({ title, icon, items }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  return (
    <>
      <Button
        id={`menu-button-${title}`}
        aria-controls={open ? `menu-${title}` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ 
          my: 2, 
          color: 'white', 
          display: 'flex', 
          alignItems: 'center' 
        }}
        startIcon={icon}
        endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      >
        {title}
      </Button>
      <Menu
        id={`menu-${title}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `menu-button-${title}`,
        }}
      >
        {items.map((item) => (
          <MenuItem 
            key={item.text}
            component={RouterLink}
            to={item.link}
            onClick={handleClose}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText>{item.text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default NavMenu;